var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Výber lokality")])]), _vm._l(this.regionChoices, function (region, index) {
    return _c('div', {
      key: index,
      staticClass: "popup-block d-flex justify-content-start align-items-center"
    }, [_c('div', {
      staticClass: "checkboxWrapper pointer",
      on: {
        "click": function click($event) {
          return _vm.toggleWholeRegion(region.id);
        }
      }
    }, [_vm.hasWholeRegion(region.id) ? _c('img', {
      staticClass: "nav-link-icon extrasmall filter-primary",
      attrs: {
        "alt": "",
        "loading": "lazy",
        "src": "https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/692aede6bc96dc77105a6e88_checkiconsimple.svg"
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "cta-email d-flex justify-content-between w-100"
    }, [_c('span', [_vm._v(_vm._s(region.name))]), _c('span', {
      staticClass: "text-small bl-color pointer",
      on: {
        "click": function click($event) {
          return _vm.openDistrictPickerPopUp(region.id);
        }
      }
    }, [_vm._v("VYBRAŤ OKRESY")])])]);
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }